import { render, staticRenderFns } from "./TMBTable.vue?vue&type=template&id=654bde9c&scoped=true"
import script from "./TMBTable.vue?vue&type=script&lang=js"
export * from "./TMBTable.vue?vue&type=script&lang=js"
import style0 from "./TMBTable.vue?vue&type=style&index=0&id=654bde9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bde9c",
  null
  
)

export default component.exports